var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.459 29.1873L28.8032 28.8564C30.1271 27.5837 32.2777 27.5819 33.6037 28.8525C34.9282 30.1217 34.9282 32.1793 33.6037 33.4484L28.8059 38.0455C27.4777 39.3182 25.3243 39.3182 23.9961 38.0455C22.6716 36.7764 22.6674 34.7199 23.9869 33.4459L24.3794 33.0668M35.6499 26.9004L36.0103 26.5534C37.3321 25.2809 37.3296 23.2233 36.0046 21.9538C34.6774 20.6821 32.5256 20.6821 31.1984 21.9538L26.4008 26.5507C25.0752 27.8209 25.0752 29.8802 26.4008 31.1504C27.7264 32.4205 29.8757 32.4205 31.2013 31.1504L31.6985 30.674",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareUrl);
export default __webpack_public_path__ + "static/media/icon_share_url.8b862b1acdada2f106832369d59df9ad.svg";
export { ForwardRef as ReactComponent };